module.exports = __webpack_public_path__ + "img/logo.e9f2473d.png";